import {Roles} from "../constants/Roles";

export default class User {

    static user = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.user : undefined;

    static isAuthenticated() {
        if (this.user !== undefined) {
            return true;
        } else {
            return false;
        }
    }

    static hasRole(roles) {
        if (this.user !== undefined && !this.user.roles) {
            if (roles.includes(this.user.role.name)) {
                return true
            } else {
                return false
            }
        }
    }

    static agency(prop) {
        if (this.isAuthenticated() && this.hasRole([...Object.values(Roles)])) {
            if (prop in this.user.agency) {
                return this.user.agency[prop];
            }
        }
    }

    static order(prop) {
        if (this.isAuthenticated() && this.hasRole([...Object.values(Roles)])) {
            if (prop in this.user.order) {
                return this.user.order[prop];
            }
        }
    }

    static brand(prop) {
        if (this.user === undefined || this.user.brand === undefined) {
            return null
        }
        if (prop in this.user.brand && this.hasRole([...Object.values(Roles)])) {
            return this.user.brand[prop];
        }
    }

    static userBearer() {
        if (this.user !== undefined) {
            const token = localStorage.getItem('user') !== null ? JSON.parse(localStorage.getItem('user')).result.token : undefined;
            return token;
        } else {
            return false;
        }
    }

    static checkUserRole(roleName) {
        if (this.user !== undefined) {
            if (this.user.roles[0].name === roleName) {
                return true
            } else
                return false
        }
    }

    static returnUserModelId() {
        if (this.user !== undefined) {
            return this.user.model_id;

        }
    }

    static getRole() {
        if (this.user !== undefined) {
            if (this.user.roles[0]) {
                return this.user.roles[0].name
            } else
                return ''
        }
    }

    static logout() {
        localStorage.removeItem('user');
    }

}



// WEBPACK FOOTER //
// ./src/helper/User.jsx